import { CommonModule, Location, ViewportScroller } from '@angular/common';
import { Component, Input, OnInit, WritableSignal, inject, signal } from '@angular/core';
import { DocumentReference } from '@angular/fire/firestore';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { NavigationComponent } from '../../components/navigation/navigation.component';
import { AssessmentsService } from '../../services/assessments.service';
import { SingleNumberDataSet, TugData, initDataTug } from '../../services/model';
import { tugToPercentSchaedigung } from '../../services/tug.functions';
import { getDateIsoString, getDateIsoStringPlus1Minute } from '../../services/util.functions';
import { AssessmentBaseComponent } from '../assessment-base/assessment-base.component';
import { SingleNumberTableInputComponent } from '../single-number-table-input/single-number-table-input.component';
import dayjs from 'dayjs';

@Component({
  selector: 'app-tug',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatOptionModule,
    MatButtonModule,
    MatCardModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatChipsModule,
    MatSelectModule,
    MatTableModule,
    RouterModule,
    MatTooltipModule,
    MatIconModule,
    NavigationComponent,
    SingleNumberTableInputComponent,
  ],
  templateUrl: './tug.component.html',
  styleUrl: './tug.component.scss',
})
export class TugComponent extends AssessmentBaseComponent implements OnInit {
  location: Location = inject(Location);
  @Input() assessmentId: string | undefined;
  private assessmentService: AssessmentsService = inject(AssessmentsService);

  private scroller: ViewportScroller = inject(ViewportScroller);
  private fb: FormBuilder = inject(FormBuilder);
  assessmentData: WritableSignal<TugData | undefined> = signal<TugData | undefined>(undefined);
  assessmentDataNew: TugData = JSON.parse(JSON.stringify(initDataTug));
  hasError = signal({
    tug: false,
  });

  form: FormGroup = this.fb.group({
    assessmentTime: [getDateIsoStringPlus1Minute(), Validators.required],
    note: [''],
  });

  onData(data: { data: Array<SingleNumberDataSet>; note: string; hasError: boolean }) {
    this.assessmentDataNew.tug.data = data.data;
    this.assessmentDataNew.tug.note = data.note;
    this.hasError.update(current => ({
      ...current,
      tug: data.hasError,
    }));
  }

  ngOnInit(): void {
    this.scroller.scrollToPosition([0, 0]);

    if (this.assessmentId) {
      this.assessmentService.getAssessment(this.assessmentId).then(data => {
        const tugData: TugData = data.data as TugData;
        // add manual
        tugData.tug.manual = initDataTug.tug.manual;

        this.assessmentData.set(tugData);
        const date = getDateIsoString(new Date(data.dateIso));
        this.form.controls['assessmentTime'].patchValue(date);

        const note = data.note;
        this.form.controls['note'].patchValue(note);

        this.assessmentDataNew = JSON.parse(JSON.stringify(this.assessmentData()));
      });
    } else {
      this.assessmentData.set(initDataTug);
      this.assessmentDataNew = JSON.parse(JSON.stringify(this.assessmentData()));
    }
  }
  onSave() {
    const tugData: TugData = this.assessmentDataNew as TugData;
    const seconds = tugData.tug.data[0].value!;
    if (this.hasError().tug || seconds === null) {
      return;
    }

    this.assessmentDataNew.tug.score = tugToPercentSchaedigung(seconds) / 100;

    if (this.assessmentId) {
      this.assessmentService
        .updateAssessment(this.assessmentId, {
          type: 'TUG',
          dateIso: this.form.controls['assessmentTime'].value,
          note: this.form.controls['note'].value ?? '',
          data: this.assessmentDataNew,
        })
        .then(res => {
          this.router.navigate(['../../../reports/assessments'], {
            relativeTo: this.route,
            queryParams: { type: 'TUG', dId: this.assessmentId },
          });
        });
    } else {
      this.assessmentService
        .createAssessment({
          type: 'TUG',
          dateIso: this.form.controls['assessmentTime'].value,
          note: this.form.controls['note'].value ?? '',
          data: this.assessmentDataNew,
        })
        .then((docRef: DocumentReference) => {
          this.router.navigate(['../../reports/assessments'], {
            relativeTo: this.route,
            queryParams: { type: 'TUG', dId: docRef.id },
          });
        });
    }
  }

  onNavigateBack() {
    if (this.assessmentId) {
      // this.router.navigate(['../../../reports/assessments'], { relativeTo: this.route });
      this.location.back();
    } else {
      // this.router.navigate(['../../reports/assessments'], { relativeTo: this.route });
      this.router.navigate(['../../assessments/new'], { relativeTo: this.route });
    }
  }
}
